// en, ko
export default {
    en: {
        //MENU
        Dashboard: 'Dashboard',
        Admin: 'Admin',
        User: 'User',
        UserFile: 'User File',
        UserFileList: 'User File List',
        FileDownloadHistory: 'File Download History',
        FileUploadHistory: 'File Upload History',
        Subscription: 'Subscription',
        SubscriptionList: 'Subscription List',
        SubscriptionPaymentHistory: 'Subscription Payment List',
        Device: 'Dashcam',
        Home: 'Home',
        Streaming: 'Streaming',
        StreamingPlayRecord: 'Streaming Play Record',
        Report: 'Report',
        FileStatisticsReport: 'File Stats Report',
        StreamingStatisticsReport: 'Streaming Stats Report',
        SubscriptionStatisticsReport: 'Subscription Stats Report',
        S3StatisticsReport: 'Cloud Stats Report',
        Logout: 'Logout',
        Profile: 'Profile',
        WowzaStatisticsReport: 'Wowza Stats Report',
        ChangeInformation: 'Change Information',
        ChangePassword: 'Change Password',
        AppDownload: 'App Download',
        ServerMonitoring: 'Server monitoring',
        ServerMonitoringEmail: 'Managing email',
        SystemManagement: 'System Management',
        VersionManagement: 'Version Management',
        NoticeManagement: 'Notice Popup Management',
        EmailManagement: 'Notice Mail Management',

        // LOGIN
        Login: 'Login',
        Register: 'Register',
        ResetPassword: 'Reset Password',
        ID: 'ID',

        //ROLE
        admin: 'supervisor',
        user: 'admin',

        //ERROR CODE
        404: '404',
        500: '500',

        //ADMIN USER STATUS
        ACTIVE: 'Active',
        LOCKED: 'Locked',
        BLOCKED: 'Blocked',
        DORMANT: 'Dormant',
        DISABLED: 'Disabled',

        //BLOCKED REASON
        RESIGNATION: 'Resignation',
        ABNORMAL: 'Abnormal',
        TESTACCOUNT: 'Test account',

        //DEVICE STATUS
        DEACTIVATED: 'Ununsed',
        ACTIVATED: 'Used',

        //SUBSCRIPTION STATUS
        SUBSCRIPTION_Y: 'Subscription',
        SUBSCRIPTION_N: 'No Subscription',

        //SERVER MOONITORING EMAIL RECEIVE
        INFORMATION: 'Information',
        EMAIL_RECEIVE: 'Email Subscription',
        RECEIVE_Y: 'Subscribe',
        RECEIVE_N: 'Unsubscribe',

        //MESSAGE
        SUCCESS: 'SUCCESS',
        ERROR: 'ERROR',
        FAIL: 'FAIL',
        INFO: 'Info',
        WELCONE_TEXT: 'Welcome back, please login to your account.',
        DUPLICATE_ADMIN_ID_MESSAGE: 'The same admin account already exists. Please enter a different account id.',
        DUPLICATE_USER_ID_MESSAGE: 'The same user account already exists. Please enter a different account id.',
        DUPLICATE_EMAIL_MESSAGE: 'The same email already exists. Please enter a different email.',
        SUBMIT_SUCCESS: 'Successfully saved.',
        ADD_ADMIN_SUCCESS: 'New admin account has successfully added.',
        UPDATE_ADMIN_SUCCESS: 'Admin account information has been changed.',
        RESET_ADMIN_SUCCESS: 'Admins account has been reset.',
        UPDATE_USER_SUCCESS: 'The user account information has been changed.',
        RESET_USER_SUCCESS: 'The user account has been reset.',
        ADD_EMAIL_SUCCESS: 'New email address has successfully added.',
        UPDATE_EMAIL_SUCCESS: 'Email address information has been changed.',
        DELETE_EMAIL_SUCCESS: 'Email address has successfully deleted.',
        UPDATE_FILE_DOWNLOAD_COUNT_SUCCESS: 'The file download count changed.',
        UPDATE_SUBSCRIPTION_SUCCESS: 'Subscription information changed.',
        UPDATE_SERVER_MONITORING_LIMIT_SUCCESS: 'Server Monitoring Limit information changed.',
        UPDATE_DEVICE_STATUS_SUCCESS: 'Dashcam status changed.',
        ADD_DEVICE_SUCCESS: 'New dashcam added.',
        NO_DEVICE_DATA: 'No data to upload. Please make sure the correct file  has been attached.',
        DEVICE_INVALID_FORMAT: 'is an invalid format.',
        DEVICE_EXCEL_EMPTY_ENTRY: 'A blank entry exists in the content.',
        INVALID_USER: 'Wrong ID or Password',
        ACCOUNT_MESSAGE_DORMANT: 'This account is currently dormant. Please contact the supervisor.',
        ACCOUNT_MESSAGE_BLOCKED: 'This account is currently blocked. Please contact the supervisor.',
        ACCOUNT_MESSAGE_LOCKED: 'This account is currently locked. Please contact the supervisor.',
        SUBMIT_CONFIRM_MESSAGE: 'Do you want to save the information?',
        RESET_CONFIRM_MESSAGE: 'Are you sure to reset this account? Clicking the CONFIRM button above will activate the account. It will send a new password to the account’s email address.',
        SUBMIT_SUBSCRIPTION_CHANGE_CONFIRM_MESSAGE: 'Subscription setting is changed. Do you want to save the information?',
        UPLOAD_CONFIRM_MESSAGE: 'Are you sure you want to upload this file?',
        DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete this email?',
        DEVICE_ADD_CONFIRM_MESSAGE: 'Are you sure to save the UUID for this dashcam?',
        PASSWORD_SAME_MESSAGE: 'The new password is the same as the current password. Please change the new password.',
        CHANGE_PASSWORD_SUCCESS: 'Password changed. Log in again with the new password.',
        CURRENT_PASSWORD_IS_NOT_MATCH: 'The current password does not match. Enter the current password correctly.',
        USER_RESET_BUTTON_MESSAGE: 'Clicking the above button above will activate the user account. It will send a new password to the user’s email address.',
        ADMIN_RESET_BUTTON_MESSAGE: ' Clicking the above button above will activate the account. It will send a new password to the admin’s email address.',
        CHECK_EXCEL_EXTENSION_MESSAGE: 'Only files saved in .xlsx, .xls and .csv formats can be attached.',
        CHECK_EXCEL_FILE_COUNT_MESSAGE: 'Only one file can be uploaded at a time.',
        CHECK_EXCEL_FORMAT_MESSAGE: 'Be sure to enter the UUID for dashcam from the second row excluding the first row of column A, and enter the security key that matches that dashcam in column B.',
        CHECK_EXCEL_EMPTY: 'The excel file is empty. Please check the file.',
        UPLOAD_FILE_SUCCESS: 'successfully uploaded.',
        DUPLICATE_DEVICE_UUID_MESSAGE: 'There is a duplicated dashcam UUID.',
        DUPLICATE_DEVICE_UUID_MESSAGE_FOR_EXCEL: 'The UUID for dashcam has been added except for duplicates.',
        CHECK_DOWNLOAD_EXCEL_FILE_MESSAGE: 'Please check the downloaded excel file.',
        PASSWORD_PATTERN: 'Passwords must contain at least 8 and no more than 20 alphanumeric and special characters.',
        CHANGE_INFORMATION_SUCCESS: 'The information has been changed.',
        INSERT_ERROR: 'The information could not be saved. Please try again.',
        DUPLICATE_EMAIL_ERROR: 'Email already exists. Please check it.',
        SUCCESS_PASSWORD_RESET: 'Password has been reset. Please check the email.',
        RESET_PASSWORD_MESSAGE: 'Enter the account name and linked email address to receive a new password.',
        CHANGE_PASSWORD_TITLE: 'Please change your password',
        CHANGE_PASSWORD_MESSAGE_RESETED: 'Your accoount or password has been reseted.',
        CHANGE_PASSWORD_MESSAGE_NEED_CHANGE: 'Your accounts password has not been changed for 45days.',
        CHANGE_PASSWORD_MESSAGE: 'Please change the password to a new one.',
        ID_OR_EMAIL_NOT_MATCH: 'ID or Email is not match. If you can not remember right information, please contact the admin.',
        STATUS_IS_NOT_ACTIVE: 'The account is not active. Please contact the admin.',
        NO_DIFFERENT_DATA: 'There are no changes.',
        SUBSCRIPTION_CHANGE: 'Subscription setting is changed.',
        SELECT_USER_TO_REPLACE: 'Select the user to replace the device.',
        BEFORE_REPLACE_DEVICE_MESSAGE: 'Be sure to check your customer account and current device information before replacing the device.',
        SELECT_REPLACE_DEVICE_MESSAGE: 'Please select a device to replace (only device with no linked account and no status in use will appear on the list.)',
        LAST_CHECK_TO_REPLACE_DEVICE_MESSAGE: 'At last, please check the information for replacing the device',
        REPLACE_DEVICE_MESSAGE: 'The changing device continues the promotion status and the promotion start date  of the current device.',
        REPLACE_DEVICE_SUCCESS: 'Device replacement succeeded.',

        //TITLE
        DEVICE_INFORMATION: 'Dashcam Information',
        SUBSCRIPTION_INFORMATION: 'Subscription Information',

        //DEVICE
        DEVICE_STATUS: 'DASHCAM STATUS',
        SERVICE_STATUS: 'DASHCAM CONNECT STATUS',
        USED_SUBSCRIBE_STATUS: 'PROMOTION STATUS',
        LAST_CONNECTED_TIME: 'LAST CONNECTED TIME',
        PROMOTION_START_DATETIME: 'PROMOTION_START_DATE',
        OUT_OF_SERVICE: 'Out of service',
        IN_SERVICE: 'In service',
        BROKEN: 'Broken',
        NOT_USED_SUBSCRIBE: 'Not used',
        USED_SUBSCRIBE: 'Used',
        USING_SUBSCRIBE: 'Using',

        //SUBSCRIPTION
        SUBSCRIPTION_DETAIL: 'SUBSCRIPTION DETAIL',
        IN_APP_BILLING_STATUS: 'IN APP BILLING STATUS',
        SUBSCRIPTION_CODE: 'SUBSCRIPTION CYCLE',
        USED_STORAGE: 'USED STORAGE',
        STORAGE_QUOTA: 'STORAGE QUOTA',
        LAST_BILLING_DATE: 'LAST BILLING DATE',
        USED_STREAMING_TIME: 'USED STREAMING TIME',
        STREAMING_QUOTA_TIME: 'STREAMING QUOTA TIME',
        USE_DATA_TRAFFIC_YN: 'USE DATA TRAFFIC YN',
        UPLOAD_TRAFFIC_QUOTA: 'UPLOAD DATA TRAFFIC QUOTA',
        UPLOAD_USED_TRAFFIC: 'USED UPLOAD DATA TRAFFIC',
        DOWNLOAD_TRAFFIC_QUOTA: 'DOWNLOAD DATA TRAFFIC QUOTA',
        DOWNLOAD_USED_TRAFFIC: 'USED DOWNLOAD DATA TRAFFIC',
        NORMAL: 'Subscription',
        PENDING: 'Pending',
        NO_PAYMENT: 'No Subscription',
        MONTHLY: 'Monthly',
        UPLOADED: 'Uploaded',
        NOT_UPLOADED: 'Not uploaded',
        UPLOAD_ERROR: 'Upload error',
        EXPIRATION_DATE: 'EXPIRATION DATE',
        TERMINATION_DATE: 'TERMINATION DATE',
        PROMOTION_YN: 'PRODUCT TYPE',
        PROMOTION_Y: 'Promotion product',
        PROMOTION_N: 'Regular product',

        //SUBSCRIPTION PAYMENT
        ORDER_ID: 'ORDER ID',
        PRODUCT_STORE_ID: 'PRODUCT STORE ID',
        STORE_TYPE: 'STORE',
        PAYMENT_STATUS: 'PAYMENT STATUS',
        BILLING_DATETIME: 'BILLING DATE',
        EXPIRED_DATE: 'EXPIRED DATE',
        CANCEL_DATETIME: 'CANCEL DATE',
        GOOGLE: 'Goole',
        APPLE: 'Apple',
        ORDER_REQUEST: 'Order request',
        VERIFY_A_PURCHASE: 'Verify a purchase',
        PURCHASE_SUCCESS: 'Purchase success',
        FAILED_VERIFY: 'Failed verify',
        FAILED_PURCHASE: 'Failed purchase',
        SUB_CANCELED: 'Subscription canceled',
        SUB_EXPIRED: 'Subscription expired',
        REVOKED: 'Revoked',

        // USER FILE
        EDIT_DOWNLOAD_COUNT: 'Edit file download count',
        USER_FILE_DETAIL: 'USER FILE DETAIL',
        EVENT_FOLDER: 'EVENT FOLDER',
        UPLOADER: 'UPLOADER',
        DEVICE_CHANNEL: 'DASHCAM CHANNEL',
        FILE_SIZE: 'FILE SIZE',
        RECORD_DATE: 'RECORD DATE',
        RECORD_TIME: 'RECORD TIME',
        FRONT: 'Front',
        CABIN: 'Cabin',
        UPLOADER_DEVICE: 'Dashcam automatically uploaded',
        UPLOADER_USER: 'User manually uploaded',
        SEQ: 'No',
        FILE_SEQ: 'FILE No',
        REQ_STATUS: 'REQUEST STATUS',
        DOWNLOAD_DATETIME: 'DOWNLOAD DATE',
        DOWNLOAD_REQUEST: 'Download request',
        DOWNLOAD_COMPLETE: 'Download complete',
        DOWNLOAD_ROLLBACK: 'Download rollback',
        UPLOAD_TIME: 'Upload Date',

        // STREAMING
        STREAM_ID: 'STREAM ID',
        START_DATETIME: 'START DATE',
        STOP_DATETIME: 'STOP DATE',
        DURATION: 'DURATION (seconds)',
        TERMINATION_CODE: 'TERMINATION STATUS',
        NORMALLY_TERMINATED: 'Nomally terminated',
        ABNORMALLY_TERMINATED: 'Abnormally terminated',
        STREAMING_UNIT: 'Unit (minutes)',

        // REPORT
        JAN: 'JAN',
        FEB: 'FEB',
        MAR: 'MAR',
        APR: 'APR',
        MAY: 'MAY',
        JUN: 'JUN',
        JUL: 'JUL',
        AUG: 'AUG',
        SEP: 'SEP',
        OCT: 'OCT',
        NOV: 'NOV',
        DEC: 'DEC',

        //BUTTON
        YES: 'Yes',
        NO: 'No',
        SUBMIT: 'Submit',
        CANCEL: 'Cancle',
        RESET: 'Reset',
        ADD_ADMIN: 'ADD ADMIN',
        ADD_EMAIL: 'ADD EMAIL',
        EXPORT_EXCEL: 'EXPORT EXCEL',
        EDIT: 'Edit',
        CONFIRM: 'Confirm',
        WARNING: 'Warning',
        ACCEPT: 'Accept',
        DETAIL: 'DETAIL',
        ADD_DEVICE: 'ADD DASHCAM',
        CLOSE: 'Close',
        USER_RESET: 'Reset user password and status',
        ADMIN_RESET: 'Reset admin password and status',
        DEVICE_EXCEL_UPLOAD: 'ADD DASHCAM BY EXCEL',
        UPLOAD: 'Upload',
        LINK: 'Link',
        GO_BACK_TO_LOGIN: 'Go Back To Login',
        DELETE: 'Delete',
        THRESHOLDE_MANAGEMENT: 'Threshold',

        //TABLE
        ROLE: 'Role',
        ADMIN_ID: 'Admin ID',
        ADMIN_NAME: 'Name',
        PHONE: 'Phone',
        ADMIN_STATUS: 'Admin Status',
        USER_ID: 'User ID',
        USER_NAME: 'User Name',
        EMAIL: 'Email',
        USER_STATUS: 'User Status',
        SUBSCRIPTION_YN: 'Subscription',
        ACTION: 'Action',
        DEVICE_UUID: 'Dashcam UUID',
        DEVICE_SECURITY_KEY: 'Dashcam Security Key',
        FILTER_BY: 'Search..',
        DEFAULT_OPTION: 'All',
        FILE_NAME: 'File Name',
        S3_UPLOAD_YN: 'Enable Cloud Upload',
        DOWNLOAD_COUNT: 'File Download Count',
        SELECTED: 'Selected',

        //
        ADD_NEW_ADMIN: 'ADD NEW ADMIN',
        UPDATE_ADMIN: 'UPDATE ADMIN',
        UPDATE_USER: 'UPDATE USER',
        PASSWORD: 'PASSWORD',
        CONFIRM_PASSWORD: 'CONFIRM PASSWORD',
        NEW_PASSWORD: 'NEW PASSWORD',
        CONFIRM_NEW_PASSWORD: 'CONFIRM NEW PASSWORD',
        BLOCKED_REASON: 'BLOCKED REASON',
        MINUTE: 'minutes',
        UPDATE_DEVICE: 'UPDATE DASHCAM',
        UPDATE_EMAIL: 'UPDATE EMAIL',
        REJECT: 'REJECT',
        OK: 'OK',

        CURRENT_PASSWORD: "CURRENT PASSWORD ",

        //REPORT TITLE
        TOTAL_UPLOAD_FILE: "Total number of files uploaded",
        TOTAL_NOT_UPLOAD_FILE: "Total number of files not uploaded",
        TOTAL_S3_STORAGE_USAGE: "Used cloud storage capacity (MB)",
        MONTHLY_SUM_FILE_DOWNLOAD_GRAPH: "Graph of total file downloads per month",
        MONTHLY_SUM_STREAMING_TIME: "Graph of total streaming time per month",
        SUM_STREAMING_TIME_BY_USER: "Total streaming time by users",
        MONTHLY_SUM_S3_USAGE_GRAPH: "Graph of total cloud storage usage per month",
        THIS_MONTH_SUBSCRIPTION_PURCHASE: "Newly subscriptions this month",
        THIS_MONTH_SUBSCRIPTION_RENEWED: "Renewed Subscriptions this month",
        THIS_MONTH_SUBSCRIPTION_CANCELED: "Canceled subscriptions this month",
        MONTHLY_SUM_SUBSCRIPTION_PAYMENT: "Graph of subscriptions and billing status per month",
        MONTHLY_WOWZA_USAGE_GRAPH: "Graph of total Wowza Usage per month",

        //DASHBOARD
        WOWZA_USAGE: "Wowza Avg Usage",
        DASHBOARD_CHANNEL: "Activity Channels / All Channels",
        DASHBOARD_CHANNEL_ERROR: "Error Channels",
        DASHBOARD_DASHCAM: "In-use Dashcams / All Dashcams",
        DASHBOARD_USER: "Subscribed Users / All Users",

        //REPORT
        FILE_DOWNLOAD_COUNTS: 'Download Counts',
        STREAMING_TIME: 'Streaming Time',
        SUBSCRIPTION_PURCHASE: 'Newly Subscription',
        SUBSCRIPTION_RENEWED: 'Renewed Subscription',
        SUBSCRIPTION_CANCLE: 'Canceled Subscription',
        USAGE: 'Usage',
        THIS_MONTH: 'This month',
        LAST_MONTH: 'Last month',

        APP_DOWNLOAD_MESSAGE: 'Please press the button below to download the file.',
        NOT_AUTHORIZED: 'You do not have access to that page.',
        DUPLICATE_DEVUCE_UUID_LIST: 'Duplicated_Dashcam_UUID_List',
        DUPLICATE_DEVUCE_UUID: 'Duplicated Dashcam UUID',

        //SERVER MONITORING
        CPU_LOAD: 'CPU Load',
        MEMORY_USAGE : 'Memory Usage',
        IO_THROUGHPUT : 'I/O Throughput',
        DISK_USAGE : 'Disk Usage',
        NETWORK_RX : 'Network Rx',
        NETWORK_TX : 'Network Tx',

        //VERSION
        ANDROID_APP_VERSION: 'Android App Version',
        IOS_APP_VERSION: 'iOS App Version',
        DVRS_FIRMWARE_VERSION: 'DVRS Firmware Version',
        VERSION_SUBMIT_MESSAGE: 'As soon as the version information is updated, it is reflected in the app and pop-up messages about the version change are displayed.',
        VERSION_CONFIRM_MESSAGE: 'Are you sure you want to update the version information?',
        VERSION_CHANGE_OPTION: 'Version Change Option : ',
        VERSION_CHANGE_VALUE: 'Version Change Value : ',
        VERSION_CHANGE_WARNING_MESSAGE: '[CAUTION] If you change the version of an app or firmware, it will immediately be reflected in the app and the customer will receive a change version pop-up message while using the app.',
        UPDATE_APP_VERSION: 'Update App Verison',
        UPDATE_FIRMWARE_VERSION: 'Update Firmware Version',
        VERSION_UPDATE_HISTORY: 'Version Update History',
        UPDATE_DEVICE: 'Updated Device',
        UPDATE_DATETIME: 'Updated Date',
        UPDATE_VERSION: 'Updated Version',

        //NOTICE
        POP_UP: 'Pop up',
        NOTICE_TITLE: 'Notice  Title',
        NOTICE_BODY: 'Notice Body',
        CREATED_BY: 'Created By',
        MODIFIED_BY: 'Modified By',
        CREATED_DATE_TIME: 'Created Date',
        MODIFIED_DATE_TIME: 'Modified Date',
        UPDATE_NOTICE: 'Update Notice',
        ADD_NOTICE: 'Add Notice',
        NOTICE_MESSAGE: '[CAUTION] The app displays a notice with the highest No. column notice among the Pop-up status is Y.',
        POPUP_Y: 'Pop up Y',
        POPUP_N: 'Pop up N',
        SUBMIT_NOTICE_MESSAGE: 'Do you want to save the information? This notice will appear in the app.',
        REJECT_CONFIRM_MESSAGE: 'Unable to save this information. There is already a notice of the pop-up status is Y.',
        ADD_NOTICE_SUCCESS: 'New notice has successfully added.',
        UPDATE_NOTICE_SUCCESS: 'Notice information has been changed.',
        SHOW_NOTICE_BODY: 'Show notice body',

        REPLACE_DEVICE: 'Replace device',
        BEFORE_CHANGE_INFO: 'Before change device info',
        REPLACE_DEVICE_INFO: 'Device info to be replaced',
        ITEM: 'Item',
        CURRENT_DEVICE: 'Current device',
        CHANGE_DEVICE: 'Change device',
        NEXT: 'NEXT',
        BEFORE: 'BEFORE',
        REPLACE: 'REPLACE',


        //NOTI EMAIL
        SEND_STATUS: 'Status',
        SCHEDULED_DATE: 'Scheduled Date',
        SEND_TARGET: 'Target',
        MAIL_TITLE: 'Title',
        MAIL_BODY: 'Contents',
        SEND_START_DATETIME: 'Start Date',
        SEND_END_DATETIME: 'End Date',
        SEND_RESULT: 'Result',
        SEND_COUNT: 'Count',
        RESERVED: 'Reserved',
        SENDING: 'Sending',
        SEND_COMPLETE: 'Complete',
        ALL_MEMBER: 'Both',
        MEMBER: 'Member Only',
        NONMEMBER: 'Non-Member Only',
        COMPOSE: 'Compose',
        REFUSE_EDIT_MAIL: 'Can not be modify this mail.',
        ADD_EMAIL: 'ADD EMAIL',
        UPDATE_EMAIL: 'UPDATE EMAIL',
        CANCEL_SEND: 'Cancel',
        CONFIRM_RESERVE_SEND: 'Are you sure you want to schedule this mail to send?',
        CONFIRM_CANCEL_MAIL: 'Are you sure you want to cancel the reservde to send?',
        REFUSE_EDIT_BEFORE_1H: '1 Hours before transfer can not be modified.',
        REFUSE_CANCEL_BEFORE_1H: '1 Hours before transfer can not be canceled.',
        REFUSE_CANCEL_MAIL: 'Can not be cancel this mail.',
        SHOW_EMAIL_BODY: 'Show contents',
        ADD_NOTIEMAIL_SUCCESS: 'Successfully reserved notice mail.',
        UPDATE_NOTIEMAIL_SUCCESS: 'Successfully modified notice mail.',
        CANCLE_NOTIEMAIL_SUCCESS: 'Successfully canceled notice mail.',
        NOTI_EMAIL: 'When saving the notice mail, it will be sent at 01:00 (UTC+0) on the scheduled date. Please be aware that mails will be sent to members, non-members, or both depending on the target.',
        NOTI_UTC: 'The time zone of [ Scheduled Date / Start DateTime / End DateTime ] is UTC+0.',
        NOTI_TIME: 'Modify mail contents and cancel can only be made up to one hour before the scheduled date.',
             

        TIME_ZONE_MESSAGE: 'The time zone of this data is UTC+0.'

    },
    ko: {
        //MENU
        Dashboard: '모니터링',
        Admin: '관리자 관리',
        User: '고객 관리',
        UserFile: '고객 파일 관리',
        UserFileList: '고객 파일 목록',
        FileDownloadHistory: '파일 다운로드 이력',
        FileUploadHistory: '파일 업로드 이력',
        Subscription: '구독 관리',
        SubscriptionList: '구독 목록',
        SubscriptionPaymentHistory: '구독 결제 목록',
        Device: '대시캠 관리',
        Home: 'Home',
        Streaming: '스트리밍 관리',
        StreamingPlayRecord: '스트리밍 재생 이력',
        Report: '보고서',
        FileStatisticsReport: '파일 통계 보고서',
        StreamingStatisticsReport: '스트리밍 통계 보고서',
        SubscriptionStatisticsReport: '구독 통계 보고서',
        S3StatisticsReport: '클라우드 저장소 통계 보고서',
        WowzaStatisticsReport: '와우자 통계 보고서',
        Logout: '로그아웃',
        Profile: '내 정보',
        ChangeInformation: '기본정보 변경',
        ChangePassword: '비밀번호 변경',
        AppDownload: '앱 다운로드',
        ServerMonitoring: '서버 모니터링',
        ServerMonitoringEmail: '모니터링 이메일 관리',
        SystemManagement: '시스템 관리',
        VersionManagement: '버전 관리',
        NoticeManagement: '공지 팝업 관리',
        EmailManagement: '공지 메일 관리',

        //LOGIN PAGE
        Login: '로그인',
        Register: '등록',
        ResetPassword: '비밀번호 초기화',
        ID: '아이디',

        //ROLE
        admin: '슈퍼바이저',
        user: '일반관리자',

        //ERROR CODE
        404: '404',
        500: '500',

        //ADMIN, USER STATUS
        ACTIVE: '활성화',
        LOCKED: '잠김',
        BLOCKED: '차단',
        DORMANT: '휴면',
        DISABLED: '탈퇴',

        //BLOCKED REASON
        RESIGNATION: '퇴사',
        ABNORMAL: '부정사용',
        TESTACCOUNT: '테스트계정',

        //DEVICE STATUS
        DEACTIVATED: '미사용',
        ACTIVATED: '사용',

        //SUBSCRIPTION STATUS
        SUBSCRIPTION_Y: '구독',
        SUBSCRIPTION_N: '미구독',

        //SERVER MOONITORING EMAIL
        INFORMATION: '정보',
        EMAIL_RECEIVE: '이메일 수신여부',
        RECEIVE_Y: '이메일 수신',
        RECEIVE_N: '이메일 수신 거부',

        //MESSGE
        SUCCESS: '성공',
        ERROR: '오류 발생',
        FAIL: '실패',
        INFO: "안내",
        WELCONE_TEXT: '아이디와 비밀번호를 입력하세요.',
        DUPLICATE_ADMIN_ID_MESSAGE: '동일한 관리자 아이디가 이미 존재합니다. 다른 아이디를 입력하세요.',
        DUPLICATE_USER_ID_MESSAGE: '동일한 고객 아이디가 이미 존재합니다. 다른 아이디를 입력하세요.',
        DUPLICATE_EMAIL_MESSAGE: '동일한 이메일이 이미 존재합니다. 다른 이메일을 입력하세요.',
        SUBMIT_SUCCESS: '정보를 저장하였습니다.',
        ADD_ADMIN_SUCCESS: '새로운 관리자 계정을 추가하였습니다.',
        UPDATE_ADMIN_SUCCESS: '관리자 계정 정보를 변경하였습니다.',
        RESET_ADMIN_SUCCESS: '관리자 계정을 초기화 하였습니다.',
        UPDATE_USER_SUCCESS: '고객 계정 정보를 변경하였습니다.',
        RESET_USER_SUCCESS: '고객 계정을 초기화 하였습니다.',
        ADD_EMAIL_SUCCESS: '새로운 이메일을 추가하였습니다.',
        UPDATE_EMAIL_SUCCESS: '이메일 정보를 변경하였습니다.',
        DELETE_EMAIL_SUCCESS: '이메일 정보를 삭제하였습니다.',
        UPDATE_FILE_DOWNLOAD_COUNT_SUCCESS: '파일 다운로드 횟수를 변경하였습니다.',
        UPDATE_SUBSCRIPTION_SUCCESS: '구독 정보를 변경하였습니다.',
        UPDATE_DEVICE_STATUS_SUCCESS: '대시캠 상태를 변경하였습니다.',
        UPDATE_SERVER_MONITORING_LIMIT_SUCCESS: '서버 모니터링 임계값을 변경하였습니다.',
        ADD_DEVICE_SUCCESS: '새로운 대시캠을 추가하였습니다.',
        NO_DEVICE_DATA: '업로드할 데이터가 없습니다. 올바른 파일을 첨부하였는지 확인하세요.',
        DEVICE_INVALID_FORMAT: '의 형식이 올바르지 않습니다.',
        DEVICE_EXCEL_EMPTY_ENTRY: '내용에 빈 항목이 존재합니다.',
        INVALID_USER: '아이디 또는 비밀번호가 일치하지 않습니다.',
        ACCOUNT_MESSAGE_DORMANT: '현재 해당 계정은 휴면 상태입니다. 슈퍼바이저에게 문의하세요.',
        ACCOUNT_MESSAGE_BLOCKED: '현재 해당 계정은 차단 상태입니다. 슈퍼바이저에게 문의하세요.',
        ACCOUNT_MESSAGE_LOCKED: '현재 해당 계정은 잠금 상태입니다. 슈퍼바이저에게 문의하세요.',
        SUBMIT_CONFIRM_MESSAGE: '정보를 저장하시겠습니까?',
        RESET_CONFIRM_MESSAGE: '해당 계정을 정말 초기화 하시겠습니까? 확인 버튼을 클릭하면 해당 계정의 상태를 활성화시키고 계정에 저장된 이메일로 재설정된 비밀번호를 전송합니다. ',
        SUBMIT_SUBSCRIPTION_CHANGE_CONFIRM_MESSAGE: '구독 여부가 변경되었습니다. 정보를 저장하시겠습니까? ',
        UPLOAD_CONFIRM_MESSAGE: '해당 파일을 정말 업로드하시겠습니까?',
        DELETE_CONFIRM_MESSAGE: '해당 이메일을 정말 삭제하시겠습니까?',
        DEVICE_ADD_CONFIRM_MESSAGE: '해당 대시캠 고유아이디를 정말 저장하시겠습니까?',
        PASSWORD_SAME_MESSAGE: '새 비밀번호가 현재 비밀번호와 동일합니다. 새 비밀번호를 변경하세요.',
        CHANGE_PASSWORD_SUCCESS: '비밀번호를 변경하였습니다. 새로운 비밀번호로 다시 로그인하세요.',
        CURRENT_PASSWORD_IS_NOT_MATCH: '입력하신 현재 비밀번호가 일치하지 않습니다. 현재 비밀번호를 올바르게 입력하세요.',
        USER_RESET_BUTTON_MESSAGE: '위 버튼을 클릭하면 해당 고객 계정의 상태를 활성화시키고 고객 계정에 저장된 이메일로 재설정된 비밀번호를 전송합니다.',
        ADMIN_RESET_BUTTON_MESSAGE: '위 버튼을 클릭하면 해당 계정의 상태를 활성화시키고 계정에 저장된 이메일로 재설정된 비밀번호를 전송합니다.',
        CHECK_EXCEL_EXTENSION_MESSAGE: '.xlsx, .xls, .csv 확장자 파일만 첨부가 가능합니다.',
        CHECK_EXCEL_FILE_COUNT_MESSAGE: '한 번에 하나의 파일만 첨부가 가능합니다.',
        CHECK_EXCEL_FORMAT_MESSAGE: '반드시 A열의 첫 번째 열을 제외한 두 번째 행부터 대시캠의 UUID를 입력하고, B열의 같은 행에 해당 대시캠과 매칭되는 보안 키를 입력하세요.',
        CHECK_EXCEL_EMPTY: '엑셀 파일이 비어있습니다. 파일을 확인하세요.',
        UPLOAD_FILE_SUCCESS: '파일 첨부 완료',
        DUPLICATE_DEVICE_UUID_MESSAGE: '중복된 대시캠 고유아이디가 있습니다.',
        DUPLICATE_DEVICE_UUID_MESSAGE_FOR_EXCEL: '중복된 대시캠 고유아이디를 제외하고 추가를 완료하였습니다.',
        CHECK_DOWNLOAD_EXCEL_FILE_MESSAGE: '다운로드 된 엑셀 파일을 확인하세요.',
        PASSWORD_PATTERN: '비밀번호는 8자 이상 20자 미만, 영문자와 숫자, 특수문자를 포함해야합니다.',
        CHANGE_INFORMATION_SUCCESS: '기본 정보를 변경하였습니다.',
        INSERT_ERROR: '정보를 저장하지 못하였습니다. 다시 시도하세요.',
        DUPLICATE_EMAIL_ERROR: '이미 존재하는 이메일입니다. 이메일을 다시 확인하세요.',
        SUCCESS_PASSWORD_RESET: '비밀번호를 초기화하였습니다. 이메일을 확인하세요.',
        RESET_PASSWORD_MESSAGE: '계정의 아이디와 해당 계정에 저장된 이메일을 입력하면, 이메일로 재설정된 비밀번호를 전송합니다.',
        CHANGE_PASSWORD_TITLE: '비밀번호를 변경하세요.',
        CHANGE_PASSWORD_MESSAGE_RESETED: '계정 또는 비밀번호가 초기화되었습니다.',
        CHANGE_PASSWORD_MESSAGE_NEED_CHANGE: '계정의 비밀번호가 오랫동안 변경되지 않았습니다.',
        CHANGE_PASSWORD_MESSAGE: '새로운 비밀번호로 변경하세요.',
        ID_OR_EMAIL_NOT_MATCH: '아이디 또는 이메일이 일치하지 않습니다. 올바른 정보가 기억나지 않는다면 슈퍼바이저에게 문의하세요.',
        STATUS_IS_NOT_ACTIVE: '계정이 활성화 상태가 아닙니다. 슈퍼바이저에게 문의하세요.',
        NO_DIFFERENT_DATA: '변경된 내용이 없습니다.',
        SUBSCRIPTION_CHANGE: '구독 여부가 변경되었습니다.',
        SELECT_USER_TO_REPLACE: '대시캠을 교체할 사용자를 선택하세요.',
        BEFORE_REPLACE_DEVICE_MESSAGE: '대시캠 교체 전, 고객 계정과 현재 대시캠 정보를 반드시 확인하세요.',
        SELECT_REPLACE_DEVICE_MESSAGE: '교체할 대시캠을 선택하세요. ( 연결된 계정이 없고 상태가 미사용중인 대시캠만 리스트에 나옵니다. )',
        LAST_CHECK_TO_REPLACE_DEVICE_MESSAGE: '마지막으로 대시캠 교체 정보를 확인하세요.',
        REPLACE_DEVICE_MESSAGE: '변경되는 대시캠은 현재 대시캠의 프로모션 상태와 프로모션 시작 날짜를 이어갑니다.',
        REPLACE_DEVICE_SUCCESS: '대시캠 교체를 완료하였습니다.',


        //TITLE
        DEVICE_INFORMATION: '대시캠 정보',
        SUBSCRIPTION_INFORMATION: '구독 정보',

        //DEVICE       
        DEVICE_STATUS: '대시캠 상태',
        SERVICE_STATUS: '대시캠 연결 상태',
        USED_SUBSCRIBE_STATUS: '프로모션 상태',
        LAST_CONNECTED_TIME: '마지막 연결 시간',
        PROMOTION_START_DATETIME: '프로모션 시작일',
        OUT_OF_SERVICE: '연결 안됨',
        IN_SERVICE: '연결 됨',
        BROKEN: '고장',
        NOT_USED_SUBSCRIBE: '미사용',
        USED_SUBSCRIBE: '사용함',
        USING_SUBSCRIBE: '사용 중',

        //SUBSCRIPTION
        SUBSCRIPTION_DETAIL: '구독 상세 정보',
        IN_APP_BILLING_STATUS: '인앱 결제 상태',
        SUBSCRIPTION_CODE: '구독 주기',
        USED_STORAGE: '스토리지 사용량',
        STORAGE_QUOTA: '스토리지 할당량',
        LAST_BILLING_DATE: '마지막 결제 일자',
        USED_STREAMING_TIME: '스트리밍 시간 사용량',
        STREAMING_QUOTA_TIME: '스트리밍 시간 할당량',
        USE_DATA_TRAFFIC_YN: '데이터 트래픽 사용여부',
        UPLOAD_TRAFFIC_QUOTA: '업로드 데이터 트래픽 할당량',
        UPLOAD_USED_TRAFFIC: '업로드 데이터 트래픽 사용량',
        DOWNLOAD_TRAFFIC_QUOTA: '다운로드 데이터 트래픽 할당량',
        DOWNLOAD_USED_TRAFFIC: '다운로드 데이터 트래픽 사용량',
        NORMAL: '구독',
        PENDING: '결제 지연',
        NO_PAYMENT: '미구독',
        MONTHLY: '월간',
        UPLOADED: '업로드 됨',
        NOT_UPLOADED: '업로드 안됨',
        UPLOAD_ERROR: '업로드 에러',
        EXPIRATION_DATE: '만료 일자',
        TERMINATION_DATE: '해지 일자',
        PROMOTION_YN: '상품 종류',
        PROMOTION_Y: '프로모션 상품',
        PROMOTION_N: '일반 상품',

        //SUBSCRIPTION PAYMENT
        ORDER_ID: '주문 번호',
        PRODUCT_STORE_ID: '상품 이름',
        STORE_TYPE: '  스토어  ',
        PAYMENT_STATUS: '결제 상태',
        BILLING_DATETIME: '청구 일자',
        EXPIRED_DATE: '만료 일자',
        CANCEL_DATETIME: '취소 일자',
        GOOGLE: '구글',
        APPLE: '애플',
        ORDER_REQUEST: '결제 요청',
        VERIFY_A_PURCHASE: '결제 검증요청',
        PURCHASE_SUCCESS: '결제 완료',
        FAILED_VERIFY: '검증 실패',
        FAILED_PURCHASE: '결제 실패',
        SUB_CANCELED: '구독 취소',
        SUB_EXPIRED: '구독 만료',
        REVOKED: '환불',

        // USER FILE
        EDIT_DOWNLOAD_COUNT: '파일 다운로드 횟수 수정',
        USER_FILE_DETAIL: '고객 파일 상세정보',
        EVENT_FOLDER: '이벤트 폴더',
        UPLOADER: '업로더',
        DEVICE_CHANNEL: '대시캠 채널',
        FILE_SIZE: '파일 크기',
        RECORD_DATE: '녹화 일자',
        RECORD_TIME: '녹화 시간',
        FRONT: '전면',
        CABIN: '내부',
        UPLOADER_DEVICE: '대시캠 자동 업로드',
        UPLOADER_USER: '고객 수동 업로드',
        SEQ: '번호',
        FILE_SEQ: '파일 번호',
        REQ_STATUS: '요청 상태',
        DOWNLOAD_DATETIME: '다운로드 일자',
        DOWNLOAD_REQUEST: '다운로드 요청',
        DOWNLOAD_COMPLETE: '다운로드 완료',
        DOWNLOAD_ROLLBACK: '다운로드 롤백',
        UPLOAD_TIME: '업로드 일자',

        // STREAMING
        STREAM_ID: '스트림 아이디',
        START_DATETIME: '시작 일시',
        STOP_DATETIME: '종료 일시',
        DURATION: '기간 (초)',
        TERMINATION_CODE: '종료 상태',
        NORMALLY_TERMINATED: '정상 종료',
        ABNORMALLY_TERMINATED: '비정상 종료',
        STREAMING_UNIT: '단위 (분)',

        // REPORT
        JAN: '1월',
        FEB: '2월',
        MAR: '3월',
        APR: '4월',
        MAY: '5월',
        JUN: '6월',
        JUL: '7월',
        AUG: '8월',
        SEP: '9월',
        OCT: '10월',
        NOV: '11월',
        DEC: '12월',

        //BUTTON
        YES: '네',
        NO: '아니오',
        SUBMIT: '저장',
        CANCEL: '취소',
        RESET: '초기화',
        ADD_ADMIN: '관리자 추가',
        ADD_EMAIL: '이메일 추가',
        EXPORT_EXCEL: '엑셀 다운로드',
        EDIT: '수정',
        CONFIRM: '확인',
        WARNING: '주의',
        ACCEPT: '승인',
        DETAIL: '상세',
        ADD_DEVICE: '대시캠 추가',
        CLOSE: '닫기',
        USER_RESET: '고객 암호 및 상태 재설정',
        ADMIN_RESET: '관리자 암호 및 상태 재설정',
        DEVICE_EXCEL_UPLOAD: '대시캠 엑셀로 추가',
        UPLOAD: '업로드',
        LINK: '바로가기',
        GO_BACK_TO_LOGIN: '로그인 페이지로 돌아가기',
        DELETE: '삭제',
        THRESHOLDE_MANAGEMENT: '임계값 관리',

        //TABLE
        ROLE: '권한',
        ADMIN_ID: '관리자 아이디',
        ADMIN_NAME: '관리자 명',
        PHONE: '핸드폰번호',
        ADMIN_STATUS: '관리자 상태',
        USER_ID: '고객 아이디',
        USER_NAME: '고객 명',
        EMAIL: '이메일',
        USER_STATUS: '고객 상태',
        SUBSCRIPTION_YN: '구독 여부',
        ACTION: '액션',
        DEVICE_UUID: '대시캠 고유아이디',
        DEVICE_SECURITY_KEY: '대시캠 보안 키',
        FILTER_BY: '검색',
        DEFAULT_OPTION: '전체',
        FILE_NAME: '파일명',
        S3_UPLOAD_YN: '클라우드 업로드 여부',
        DOWNLOAD_COUNT: '파일 다운로드 횟수',
        SELECTED: '선택',

        //
        ADD_NEW_ADMIN: '관리자 추가',
        UPDATE_ADMIN: '관리자 수정',
        UPDATE_USER: '고객 수정',
        PASSWORD: '비밀번호',
        CONFIRM_PASSWORD: '비밀번호 확인',
        NEW_PASSWORD: '새 비밀번호',
        CONFIRM_NEW_PASSWORD: '새 비밀번호 확인',
        BLOCKED_REASON: '차단 사유',
        MINUTE: '분',
        UPDATE_DEVICE: '대시캠 수정',
        UPDATE_EMAIL: '이메일 수정',
        REJECT: '불가',
        OK: '확인',

        CURRENT_PASSWORD: "현재 비밀번호",

        //REPORT TITLE
        TOTAL_UPLOAD_FILE: "전체 업로드된 파일 개수",
        TOTAL_NOT_UPLOAD_FILE: "전체 업로드되지 않은 파일 개수",
        TOTAL_S3_STORAGE_USAGE: "현재까지 사용된 클라우드 저장소 용량 (MB)",
        MONTHLY_SUM_FILE_DOWNLOAD_GRAPH: "월별 파일 다운로드 횟수 합계 그래프",
        MONTHLY_SUM_STREAMING_TIME: "월별 스트리밍 시간 합계 그래프",
        SUM_STREAMING_TIME_BY_USER: "고객별 스트리밍 시간 합계",
        MONTHLY_SUM_S3_USAGE_GRAPH: "월별 클라우드 저장소 사용량 합계 그래프",
        THIS_MONTH_SUBSCRIPTION_PURCHASE: "이번 달 신규 구독",
        THIS_MONTH_SUBSCRIPTION_RENEWED: "이번 달 갱신된 구독",
        THIS_MONTH_SUBSCRIPTION_CANCELED: "이번 달 취소된 구독",
        MONTHLY_SUM_SUBSCRIPTION_PAYMENT: "월별 구독 결제 현황 그래프",
        MONTHLY_WOWZA_USAGE_GRAPH: "월별 와우자 사용량 합계 그래프",

        //DASHBOARD
        WOWZA_USAGE: "와우자 평균 사용량",
        DASHBOARD_CHANNEL: "활동 채널 / 전체 채널",
        DASHBOARD_CHANNEL_ERROR: "오류 채널",
        DASHBOARD_DASHCAM: "사용중인 대시캠 / 전체 대시캠",
        DASHBOARD_USER: "구독 고객 / 전체 고객",

        //REPORT
        FILE_DOWNLOAD_COUNTS: '다운로드 횟수',
        STREAMING_TIME: '스트리밍 시간',
        SUBSCRIPTION_PURCHASE: '신규 구독',
        SUBSCRIPTION_RENEWED: '갱신된 구독',
        SUBSCRIPTION_CANCLE: '취소된 구독',
        USAGE: '사용량',
        THIS_MONTH: '이번 달',
        LAST_MONTH: '저번 달',


        APP_DOWNLOAD_MESSAGE: '아래 버튼을 눌러 파일을 다운로드 해주세요.',
        NOT_AUTHORIZED: '해당 페이지에 대한 접근권한이 없습니다. ',
        DUPLICATE_DEVUCE_UUID_LIST: '중복_대시캠_고유아이디_리스트',
        DUPLICATE_DEVUCE_UUID: '중복된 대시캠 고유아이디',

        //SERVER MONITORING
        CPU_LOAD: 'CPU Load',
        MEMORY_USAGE : 'Memory Usage',
        IO_THROUGHPUT : 'I/O Throughput',
        DISK_USAGE : 'Disk Usage',
        NETWORK_RX : 'Network Rx',
        NETWORK_TX : 'Network Tx',

        //VERSION
        ANDROID_APP_VERSION: 'Android App Version',
        IOS_APP_VERSION: 'iOS App Version',
        DVRS_FIRMWARE_VERSION: 'DVRS Firmware Version',
        VERSION_SUBMIT_MESSAGE: '버전 정보를 업데이트할 시 곧바로 앱에 반영되며, 버전 변경 관련 팝업메세지가 표출됩니다.',
        VERSION_CONFIRM_MESSAGE: '정말 버전 정보를 업데이트 하시겠습니까?',
        VERSION_CHANGE_OPTION: '버전 변경 항목 : ',
        VERSION_CHANGE_VALUE: '버전 변경 버전 : ',
        VERSION_CHANGE_WARNING_MESSAGE: '앱 또는 펌웨어의 버전을 변경할시, 즉시 앱에 반영 되어 고객이 앱 사용 중 버전 변경 팝업 메세지가 표출되므로 주의하여 변경하십시오.',
        UPDATE_APP_VERSION: '앱 버전 업데이트',
        UPDATE_FIRMWARE_VERSION: '펌웨어 버전 업데이트',
        VERSION_UPDATE_HISTORY: '버전 업데이트 히스토리',
        UPDATE_DEVICE: '업데이트 기기',
        UPDATE_DATETIME: '업데이트 일자',
        UPDATE_VERSION: '업데이트 버전',

        //NOTICE
        POP_UP: '팝업여부',
        NOTICE_TITLE: '공지 제목',
        NOTICE_BODY: '공지 내용',
        CREATED_BY: '작성자',
        MODIFIED_BY: '수정자',
        CREATED_DATE_TIME: '작성일자',
        MODIFIED_DATE_TIME: '수정일자',
        UPDATE_NOTICE: '공지사항 수정',
        ADD_NOTICE: '공지사항 추가',
        NOTICE_MESSAGE: '앱에 표출되는 공지사항은 팝업 여부가 "게시"인 공지사항 중 번호가 가장 높은 공지사항입니다. ',
        POPUP_Y: '게시',
        POPUP_N: '미게시',
        SUBMIT_NOTICE_MESSAGE: '공지사항 정보를 저장하시겠습니까? 앱 사용자들에게 해당 공지사항이 바로 표출됩니다.',
        REJECT_CONFIRM_MESSAGE: '공지사항 정보를 저장할 수 없습니다. 이미 게시중인 공지사항이 있습니다.',
        ADD_NOTICE_SUCCESS: '새로운 공지사항을 추가하였습니다.',
        UPDATE_NOTICE_SUCCESS: '공지사항을 변경하였습니다.',
        SHOW_NOTICE_BODY: '공지사항 내용 보기',

        REPLACE_DEVICE: '대시캠 교체',
        BEFORE_CHANGE_INFO: '교체 전 정보',
        REPLACE_DEVICE_INFO: '교체할 대시캠 정보',
        ITEM: '항목',
        CURRENT_DEVICE: '현재 대시캠',
        CHANGE_DEVICE: '변경 대시캠',
        NEXT: '다음',
        BEFORE: '이전',
        REPLACE: '교체',

        //NOTI EMAIL
        SEND_STATUS: '전송 상태',
        SCHEDULED_DATE: '전송 예약 날짜',
        SEND_TARGET: '전송 대상',
        MAIL_TITLE: '메일 제목',
        MAIL_BODY: '메일 내용',
        SEND_START_DATETIME: '전송 시작 일자',
        SEND_END_DATETIME: '전송 완료 일자',
        SEND_RESULT: '전송 결과',
        SEND_COUNT: '전송 수',
        RESERVED: '예약됨',
        SENDING: '전송중',
        SEND_COMPLETE: '전송완료',
        CANCEL_SEND: '전송취소',
        ALL_MEMBER: '모두',
        MEMBER: '회원만',
        NONMEMBER: '비회원만',
        COMPOSE: '메일 작성',
        REFUSE_EDIT_MAIL: '해당 메일은 수정이 불가합니다.',
        ADD_EMAIL: '메일 추가',
        UPDATE_EMAIL: '메일 수정',
        CANCEL_SEND: '전송 취소',
        CONFIRM_RESERVE_SEND: '정말로 해당 메일 전송을 예약하시겠습니까?',
        CONFIRM_CANCEL_MAIL: '정말로 해당 메일 전송을 예약을 취소하시겠습니까?',
        REFUSE_EDIT_BEFORE_1H: '발송 1시간전 메일은 수정할 수 없습니다.',
        REFUSE_CANCEL_BEFORE_1H: '발송 1시간전 메일은 취소할 수 없습니다.',
        REFUSE_CANCEL_MAIL: '취소할 수 없는 메일입니다.',
        SHOW_EMAIL_BODY: '내용 보기',
        ADD_NOTIEMAIL_SUCCESS: '공지 메일이 예약되었습니다.',
        UPDATE_NOTIEMAIL_SUCCESS: '공지 메일을 수정하였습니다.',
        CANCLE_NOTIEMAIL_SUCCESS: '공지 메일 전송이 취소되었습니다.',
        NOTI_EMAIL: '공지 메일 저장시 지정한 날짜의 UTC+0 기준 01시에 발송됩니다. 전송 대상 선택에 따라 회원 및 비회원 또는 전체에게 메일이 발송되므로 유의하시기 바랍니다.',
        NOTI_UTC: ' [ 전송 예약 날짜 / 전송 시간일자 / 전송 완료일자 ] 는 모두 UTC +0 기준입니다.',
        NOTI_TIME: '메일 내용 수정 및 전송 취소는 지정한 전송 예약 시간의 1시간 전 까지만 가능합니다.',

        TIME_ZONE_MESSAGE: '해당 데이터의 기준 시간대는 UTC+0 입니다.'

    },

}